import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import Pagination from '@/components/Pagination.vue';
import { useRouter, useRoute } from 'vue-router';
import { defineComponent, getCurrentInstance, ref, toRefs, reactive, onActivated, nextTick, computed, watch } from 'vue';
import { useStore } from '@/store/index';
import Keys from '@/constant/key';
import { joinParams, downloadFile } from '@/utils/index';
import { CheckStatus, ProductO } from '@/enums/product';
import SelectBrand from '@/components/SelectBrand.vue';
import SelectCity from '@/components/SelectCity.vue';
import SelectMerchantSecondBrand from '@/components/SelectMerchantSecondBrand.vue';
import { checkRollback } from '@/apis/product';
import { offTypes, filterTypes } from './enum';
import { debounce } from 'lodash';
import { getBrandListApi } from '@/apis/brand';
export default defineComponent({
  name: 'VoucherList',
  components: {
    SelectBrand,
    Pagination,
    SelectCity,
    SelectMerchantSecondBrand
  },
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const store = useStore();
    const route = useRoute();
    const userGroups = store.state.user.userInfo.group_id.split(',');
    const goods = ref([]);
    const cityList = ref([]);
    const uploadRef = ref();
    const isKd = store.state.user.userInfo.is_kd; // 是否为非快递蛋糕
    const isSnacks = store.state.user.userInfo.is_snacks; // 是否为零食 1- 零食+蛋糕品类'   2-纯零食类  3-其他
    // 判断是否在3月31日24点之前
    const isBeforeMarch31 = ref(new Date() < new Date('2026-03-18 23:59:59'));
    const checkAdd = type => {
      // if (addProductDisabled.value) {
      //     return proxy.$message.error({
      //         message: '春节假期1月20日到2月4日之间暂不支持提报新品',
      //         duration: 5000
      //     })
      // }
      if (type == 1) {
        const {
          source
        } = state.filters;
        router.push(`/merchant-admin/product-edit?o=${ProductO['新增']}&source=${source}`);
      } else if (type == 2) {
        state.productDialogShow = true;
      }
    };
    // 指定时间段禁止上传商品
    const addProductDisabled = computed(() => {
      // 2025年1月1日至2025年2月28日禁止上传商品
      const startDate = new Date('2025-01-20');
      const endDate = new Date('2025-02-04');
      const now = new Date();
      return now >= startDate && now <= endDate;
    });
    const state = reactive({
      serviceUploadSuccess: false,
      fileList: [],
      multiple: true,
      user_id: store.state.user.userInfo.id,
      user_type: store.state.user.userInfo.user_type,
      filters: {
        source: route.meta.v,
        brand_id: '',
        brand_name: '',
        secondary_id: '',
        second_brand_name: '',
        tmp_secondary_id: [],
        title: '',
        status: route.query.status || null,
        soldout_type: route.query.type || '',
        pro_tag: '',
        admin_name: '',
        start_date: '',
        end_date: '',
        is_yushou: '0',
        yushou_start_date: '',
        yushou_end_date: '',
        city_id: '',
        start_price: '',
        end_price: '',
        goods_type: '2',
        start_shop_discount: '',
        end_shop_discount: '',
        stock: '0',
        page: 1,
        page_size: 10,
        distribution_rule_id: route.query.distribution_rule_id || '',
        cat_id: ''
      },
      cat_id: '',
      yushouTime: 0,
      tableData: [],
      total: 0,
      shelf: {
        soldout_type: '',
        soldout_reson: '',
        status: '',
        product_ids: ''
      },
      priceDialogShow: false,
      giftDialogShow: false,
      batchChangePriceUrl: '',
      file: '',
      is_time: 0,
      examine_time: null,
      hour: '',
      brandList: [],
      couponBrandList: [],
      brandProps: {
        value: 'id',
        label: 'name'
      },
      brandId: null,
      productDialogShow: false,
      ServiceProductDialogShow: false,
      productShelfShow: false,
      SkuDialogVisible: false,
      uploadProductList: [],
      offIds: [],
      errorMsg: '',
      // cityList:               [],      //城市列表
      specsList: [],
      product_id: '',
      combinedCityIds: [],
      cityListProps: {
        label: 'name',
        value: 'id'
      },
      processedCityList: [],
      showPermanentTip: false,
      lowSalesCount: 0,
      doubleClickStockFlag: false,
      cityDialogShow: false,
      cityRadio: 1,
      brandCityList: [],
      newCityList: [],
      cityIds: [],
      cityListLen: 0,
      isSelectedAll: false,
      isIndeterminate: false,
      product_detail: {},
      currentRow: {},
      salesNumDialogShow: false,
      commentDialogShow: false,
      currentProduct: {},
      commentList: [],
      // 获取列表数据
      getList(params = {}) {
        if (state.filters.goods_type == '3') {
          state.filters.is_choiceness = 1;
        } else {
          state.filters.is_choiceness = '';
        }
        if (state.doubleClickStockFlag) {
          params = {
            ...params,
            stock: 2
          };
        }
        const filters = {
          ...state.filters,
          ...params
        };
        proxy.$http.get('/cake_api/get_product_list', filters).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          state.tableData = data.data;
          state.total = data.total;
        });
        const mergedParams = Object.assign({}, filters, {
          stock: 2
        });
        proxy.$http.get('/cake_api/get_product_list', mergedParams).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          state.lowSalesCount = data.total;
        });
      },
      handleSoldoutTypeChange(value) {
        state.showPermanentTip = value === offTypes['永久下架'];
      },
      handleFileChange(file, fileList) {
        state.fileList = fileList; // 更新文件列表
      },
      // 标签切换
      onTabChange() {
        state.filters.second_brand_name = '';
        state.filters.title = '';
        state.filters.status = null;
        state.filters.admin_name = '';
        state.filters.start_date = '';
        state.filters.end_date = '';
        state.filters.page = 1;
        state.getList();
      },
      onBrandChange(val) {
        state.filters.brand_id = val;
        //根据搜索的品牌来看属于什么类别
        if (state.filters.brand_id) {
          state.cat_id = state.brandList.find(item => item.id == val).cat_id;
        } else {
          state.cat_id = '';
        }
      },
      onSelectedSecondBrandChange(val) {
        state.filters.secondary_id = val.join(',');
      },
      onSelectedChange(val) {
        state.filters.city_id = val;
      },
      // 商品批量添加前回调
      onProductBeforeUpload() {
        if (state.brandId) {
          return true;
        } else {
          proxy.$message({
            type: 'error',
            message: '当前用户未关联品牌'
          });
          return false;
        }
      },
      // 商品批量添加成功回调
      onProductUploadSuccess(res) {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          return state.errorMsg = `*${msg}`;
        }
        proxy.$message({
          type: 'success',
          message: '上传成功'
        });
        setTimeout(() => {
          state.filters.goods_type = '1';
          state.getList();
          state.onProductUploadCancel();
        }, 1000);
      },
      // 确认添加
      onProductUploadSure() {
        const {
          brandId: brand_id
        } = state;
        if (!brand_id) {
          return proxy.$message({
            type: 'error',
            message: '当前用户未关联品牌'
          });
        }
        proxy.$http.post('/admin/shop_product/add_shop_goods', {
          brand_id
        }).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code === 200) {
            proxy.$message({
              type: 'success',
              message: '添加成功'
            });
            setTimeout(() => {
              state.getList();
              state.onProductUploadCancel();
            });
          } else {
            state.errorMsg = `*【${data}】 ${msg}`;
          }
        });
      },
      // 取消添加
      onProductUploadCancel() {
        state.brandId = '';
        state.productDialogShow = false;
        state.uploadProductList = [];
        state.errorMsg = '';
        proxy.$refs.batchProductForm.clearFiles();
      },
      // 客服批量添加弹窗打开
      openServicerDialog() {
        state.serviceUploadSuccess = false;
        state.ServiceProductDialogShow = true;
      },
      //取消客服批量添加
      onServiceProductUploadCancel() {
        state.ServiceProductDialogShow = false;
        proxy.$refs.ServiceBatchProductForm.clearFiles();
      },
      onServiceUploadSuccess(res) {
        const {
          code,
          data,
          msg
        } = res;
        if (code == 200) {
          proxy.$message({
            type: 'success',
            message: msg
          });
          state.onServiceProductUploadCancel();
          state.getList();
        } else {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
      },
      // 客服批量添加商品
      ServiceDialogSubmit() {
        proxy.$refs.ServiceBatchProductForm.submit();
      },
      // 文件更改事件处理
      handleServiceFileChange(file, fileList) {
        // 当有文件时禁用按钮
        state.serviceUploadSuccess = fileList.length > 0;
        proxy.fileList = fileList;
      },
      // 处理文件移除事件
      handleServiceFileRemove(file, fileList) {
        // 每次移除文件时检查文件列表
        state.serviceUploadSuccess = fileList.length > 0; // 更新按钮禁用状态
        proxy.fileList = fileList;
      },
      onUploadSuccess(res) {
        const {
          code,
          data,
          msg
        } = res;
        if (code == 200) {
          proxy.$message({
            type: 'success',
            message: msg
          });
          state.dialogBeforeCloseGift();
        } else {
          proxy.$confirm(`${msg}`, '提示', {
            type: 'error',
            showCancelButton: false,
            confirmButtonText: '清除文件',
            closeOnClickModal: false // 禁止点击空白处关闭弹窗
          }).then(() => {
            proxy.$refs.uploadRef.clearFiles();
            state.fileList = [];
          }).catch(() => {
            proxy.$refs.uploadRef.clearFiles();
            state.fileList = [];
            console.log('取消操作');
          });
        }
      },
      //确定上传
      dialogSubmit() {
        proxy.$refs.uploadRef.submit();
      },
      // 关闭上传更新弹框
      dialogBeforeCloseGift() {
        //清除数据
        proxy.$refs.uploadRef.clearFiles();
        state.fileList = [];
        state.giftDialogShow = false;
      },
      //打开下架原因弹窗
      openDialog(row) {
        let arr = [1, 2, 3, 4, 5];
        // if (!row.soldout_type.some(value => arr.includes(value))) {
        //     state.shelf.soldout_type = ''
        //     console.log(state.shelf.soldout_type)
        // }else {
        //     state.shelf.soldout_type = row.soldout_type.map(str => parseFloat(str))
        // }
        if (arr.includes(row.soldout_type)) {
          state.shelf.soldout_type = row.soldout_type;
        } else {
          //@ts-ignore
          state.shelf.soldout_type = '';
        }
        state.shelf.soldout_reson = row.soldout_reson;
        //@ts-ignore
        state.shelf.status = row.status ^ 1;
        state.shelf.product_ids = row.id;
        state.productShelfShow = true;
      },
      //取消下架
      onProductShelfShow() {
        state.shelf.soldout_type = '';
        state.shelf.soldout_reson = '';
        state.shelf.status = '';
        state.shelf.product_ids = '';
        state.productShelfShow = false;
        nextTick(() => {
          proxy.$refs['shelfProductForm'].clearValidate();
        });
      },
      onGetCityList: () => {
        proxy.$http.get('/ptapi/city/city_list').then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          cityList.value = data.map(item => ({
            ...item,
            disabled: false
          }));
        });
      },
      //配置商品规格城市、SKU
      SkuDialogVisibleClose() {
        state.combinedCityIds = [];
        state.SkuDialogVisible = false;
      },
      // 表格 index 连续
      tableIndex: index => {
        const {
          page,
          page_size
        } = state.filters;
        return (page - 1) * page_size + index + 1;
      },
      search() {
        state.filters.page = 1;
        state.doubleClickStockFlag = false;
        state.getList();
        if (state.filters.is_yushou == '1' || state.filters.yushou_start_date || state.filters.yushou_end_date) {
          state.yushouTime = 1;
        } else {
          state.yushouTime = 0;
        }
      },
      onPageChange(val) {
        state.filters.page = val;
        state.getList();
      },
      onSizeChange(val) {
        state.filters.page_size = val;
        state.getList();
      },
      // 跳转至编辑页
      toEdit: (row, t) => {
        const {
          goods_type,
          source
        } = state.filters;
        if (t === 'edit' && row.soldout_type == 10) {
          return proxy.$message({
            type: 'error',
            message: '该商品为永久下架，不可再次上架'
          });
        }
        // 代表当前商品有在审核中的审核单
        if (t === 'edit' && row.preparation_type == 1) {
          return proxy.$message({
            type: 'warning',
            message: '此商品已修改正在审核中，请前往审核列表查看'
          });
        }
        if (row.cat_id == 4) {
          router.push(`/merchant-admin/coupon-product-${t}?id=${row.id}&source=${source}&t=${t}&o=${goods_type == '1' ? ProductO['待上线'] : ProductO['已上线']}`);
        } else {
          router.push(`/merchant-admin/product-edit?id=${row.id}&source=${source}&t=${t}&o=${goods_type == '1' ? ProductO['待上线'] : ProductO['已上线']}`);
        }
      },
      //配置商品规格SKU、城市弹窗
      toConfig: row => {
        state.product_id = row.id;
        //调用商品详情接口
        state.getProductInfo(row.id);
        //调用配置商品详情接口
        proxy.$http.post('/cake_api/nxSkuList', {
          product_id: row.id
        }).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          if (!data) {
            state.addRow();
          } else {
            goods.value = data.map(item => {
              return {
                ...item,
                city_list: item.city_list.split(',').map(Number)
              };
            });
          }
        });
        state.SkuDialogVisible = true;
      },
      checkForDuplicateSpecs: id => {
        // 清空 combinedCityIds 数组
        state.combinedCityIds = [];
        // 仅在有有效的 id 时执行后续操作
        if (id) {
          // 创建一个 Set 来存储唯一的城市ID
          let uniqueCityIds = new Set();
          // 遍历 goods，寻找相同的 specsId
          goods.value.forEach(item => {
            if (item.specs_id === id && item.city_list != '') {
              // 添加城市ID到 Set 中，自动去除重复项
              item.city_list.forEach(cityId => uniqueCityIds.add(cityId));
            }
          });
          // 将 Set 转换回数组
          state.combinedCityIds = Array.from(uniqueCityIds);
        }
      },
      isCityDisabled: id => {
        // 清空 combinedCityIds 数组
        // state.combinedCityIds = [];
        // 仅在有有效的 id 时执行后续操作
        if (id) {
          // 创建一个 Set 来存储唯一的城市ID
          let uniqueCityIds = new Set();
          // 遍历 goods，寻找相同的 specsId
          goods.value.forEach(item => {
            if (item.specs_id === id && item.city_list != '') {
              // 添加城市ID到 Set 中，自动去除重复项
              item.city_list.forEach(cityId => uniqueCityIds.add(cityId));
            }
          });
          // 将 Set 转换回数组
          state.combinedCityIds = Array.from(uniqueCityIds);
        }
        cityList.value = cityList.value.map(city => ({
          ...city,
          disabled: Boolean(state.combinedCityIds.includes(city.id))
        }));
      },
      //获取商品信息
      getProductInfo: id => {
        const {
          goods_type
        } = state.filters;
        proxy.$http.post('/cake_api/product_details', {
          save_id: id,
          is_on_line: goods_type == '1' ? ProductO['待上线'] : ProductO['已上线']
        }).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          state.specsList = data.specs_list;
        });
      },
      toggleShowAll(row) {
        row.showAll = !row.showAll;
      },
      //添加商品规格SKU、城市行
      addRow() {
        const newRow = {
          specs_id: '',
          city_list: '',
          sku: ''
        };
        goods.value.push(newRow);
      },
      //删除商品规格SKU、城市行
      removeRow(index) {
        goods.value.splice(index, 1);
      },
      checkSpecData: () => {
        const hasEmptyRow = goods.value.some(row => {
          return !row.specs_id || !row.sku || row.city_list.length < 1;
        });
        return hasEmptyRow;
      },
      //保存商品规格SKU、城市
      updateRow: id => {
        if (state.checkSpecData()) {
          // 弹出错误提示框，提示用户有空元素
          return proxy.$message({
            type: 'error',
            message: '每行内不能有空元素'
          });
        }
        const updatedGoods = goods.value.map(item => {
          return {
            ...item,
            city_list: item.city_list.join(',') // 将city_list数组转换为以逗号分隔的字符串
          };
        });
        proxy.$http.post('/cake_api/nxSkuUp', {
          product_id: id,
          goods: updatedGoods
        }).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          proxy.$message({
            type: 'success',
            message: msg
          });
          state.SkuDialogVisibleClose();
        });
      },
      //撤销审核
      onRollback: save_id => {
        proxy.$confirm(`确定要撤销吗?`, '提示', {
          type: 'warning'
        }).then(() => {
          checkRollback({
            save_id
          }).then(res => {
            const {
              code,
              data,
              msg
            } = res;
            if (code == 200) {
              proxy.$message({
                type: 'success',
                message: '审核撤回成功'
              });
              state.getList();
            } else {
              proxy.$message({
                type: 'error',
                message: msg
              });
            }
          });
        }).catch(() => {
          console.log('取消上下架操作');
        });
      },
      // 选中监听
      onSelectionChange(val) {
        state.offIds = val.map(item => item.id).join(',');
      },
      // 行样式
      getRowClassName({
        row
      }) {
        if (state.filters.goods_type === '4' && row.status === -2) {
          return 'red-row';
        }
        return '';
      },
      // 批量导出
      onExport() {
        //商户端导出
        if (state.filters.source == 2) {
          if (!state.filters.brand_id) {
            return proxy.$message({
              type: 'error',
              message: '请选择品牌'
            });
          }
          window.open(`${Keys.baseUrl}/cake_api/shop_productOutput?${joinParams({
            ...state.filters,
            user_id: store.state.user.userInfo.id
          })}`);
        } else {
          window.open(`${Keys.baseUrl}/cake_api/productOutput?${joinParams({
            ...state.filters,
            user_id: store.state.user.userInfo.id,
            products_ids: state.offIds
          })}`);
        }
      },
      // 批量
      batchChangePrice() {
        state.priceDialogShow = true;
      },
      // 批量修改-上传文件成功
      onAvatarSuccess: res => {
        if (res.code == '0') {
          proxy.$message({
            type: 'success',
            message: res.msg
          });
        } else {
          proxy.$message({
            type: 'error',
            message: res.msg
          });
        }
        // state.dialogBatchDelivery = false;
        state.file = '';
      },
      // 批量修改-上传文件之前
      beforeAvatarUpload: file => {
        state.file = file;
        return new Promise((resolve, reject) => {
          nextTick(() => {
            let {
              is_time,
              examine_time,
              hour
            } = state;
            if (is_time && !examine_time) {
              return proxy.$message({
                type: 'error',
                message: '请选择定时上架时间'
              });
            }
            state.batchChangePriceUrl = `/api/admin/shop_product/batchChangePrice?is_time=${is_time}&examine_time=${examine_time ? examine_time + ' ' + (hour || hourList[0]) : ''}`;
            resolve(true);
          });
        });
      },
      // 提交批量修改上传
      submitUpload: () => {
        proxy.$refs.batchDeliveryForm.submit();
      },
      // 批量修改弹框关闭前
      beforePriceDialogClose: () => {
        proxy.$refs.batchDeliveryForm.clearFiles();
        state.file = '';
        state.is_time = 0;
        state.examine_time = null;
        state.hour = '';
        state.priceDialogShow = false;
      },
      // 修改上下架状态
      onChangeStatus: row => {
        const {
          id,
          status,
          title,
          soldout_type,
          secondary_brands_status
        } = row;
        if (status == 0 && soldout_type == 10) {
          return proxy.$message({
            type: 'error',
            message: '该商品为永久下架，不可再次上架'
          });
        }
        if (status == 0 && secondary_brands_status == 0) {
          return proxy.$message({
            type: 'error',
            message: '当前二级品牌已下架不可提交'
          });
        }
        //如果是上架状态且是运营要操作下架，客服也可以操作下架
        //@ts-ignore
        if (status == 1 && (userGroups.includes('3') || userGroups.includes('1') || userGroups.includes('77') || userGroups.includes('21'))) {
          //打开弹窗
          state.openDialog(row);
        } else {
          proxy.$confirm(`确定要 ${status == 0 ? '上架' + title + '进入审核流' : '下架' + title} 吗?`, '提示', {
            type: 'warning'
          }).then(() => {
            proxy.saveStatus(id, status ^ 1);
          }).catch(() => {
            console.log('取消上下架操作');
          });
        }
      },
      // 批量下架
      onBatchOff() {
        const {
          offIds
        } = state;
        if (!offIds.length) {
          return proxy.$message({
            type: 'error',
            message: '请选择下架商品'
          });
        }
        proxy.$confirm('确定要下架此批商品吗?', '提示', {
          type: 'warning'
        }).then(() => {
          state.saveStatus(offIds, 0);
        }).catch(() => {
          console.log('取消批量下架');
        });
      },
      // 修改商品状态
      saveStatus: (product_ids, status) => {
        //下架必须选择下架类型
        if (status == 0 && userGroups.includes('3') && !state.shelf.soldout_type || status == 0 && userGroups.includes('1') && !state.shelf.soldout_type) {
          return proxy.$message({
            type: 'error',
            message: '请选择下架类型'
          });
        }
        if (state.shelf.soldout_type) {
          proxy.$refs['shelfProductForm'].validate(valid => {
            if (valid) {
              proxy.$http.post('/cake_api/product_status', {
                product_ids,
                soldout_type: state.shelf.soldout_type,
                soldout_reson: state.shelf.soldout_reson,
                status
              }).then(res => {
                const {
                  code,
                  data,
                  msg
                } = res;
                if (code == 5001) {
                  return proxy.$confirm(msg, '提示', {
                    type: 'warning',
                    confirmButtonText: '去完善'
                  }).then(() => {
                    router.push(`/merchant-admin/product-edit?id=${product_ids}&t=edit&o=${state.filters.goods_type == '1' ? ProductO['待上线'] : ProductO['已上线']}&v=1`);
                  }).catch(() => {
                    console.log('取消去完善操作');
                  });
                } else if (code != 200) {
                  return proxy.$message({
                    type: 'error',
                    message: msg
                  });
                }
                proxy.$message({
                  type: 'success',
                  message: '保存成功'
                });
                state.productShelfShow = false;
                state.getList();
              });
            }
          });
        } else {
          proxy.$http.post('/cake_api/product_status', {
            product_ids,
            status
          }).then(res => {
            const {
              code,
              data,
              msg
            } = res;
            if (code == 5001) {
              return proxy.$confirm(msg, '提示', {
                type: 'warning',
                confirmButtonText: '去完善'
              }).then(() => {
                router.push(`/merchant-admin/product-edit?id=${product_ids}&t=edit&o=${state.filters.goods_type == '1' ? ProductO['待上线'] : ProductO['已上线']}&v=1`);
              }).catch(() => {
                console.log('取消去完善操作');
              });
            } else if (code != 200) {
              return proxy.$message({
                type: 'error',
                message: msg
              });
            }
            proxy.$message({
              type: 'success',
              message: '保存成功'
            });
            state.getList();
          });
        }
      },
      //获取品牌列表
      getBrandList: () => {
        proxy.$http.get('/cake_api/get_brand_list').then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          state.brandList = res.data;
        });
      },
      getCouponBrandList: () => {
        getBrandListApi({
          if_body: 1
        }).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          state.couponBrandList = res.data;
        });
      },
      // 下载手册文件
      onPreview: () => {
        window.open('https://dgss-oss-zs.oss-cn-beijing.aliyuncs.com/shop_vedio/收费附件添加教程1723017670.docx');
      },
      //开通城市
      onCityDialogClose: () => {
        state.cityDialogShow = false;
      },
      onCitySubmit: () => {
        var _state$product_detail, _state$product_detail2;
        state.cityDialogShow = false;
        // 根据source字段判断来源页面1运营端、2商户端
        const params = {
          source: state.filters.source,
          brand_id: (_state$product_detail = state.product_detail) === null || _state$product_detail === void 0 ? void 0 : _state$product_detail.brand_id,
          product_id: (_state$product_detail2 = state.product_detail) === null || _state$product_detail2 === void 0 ? void 0 : _state$product_detail2.id,
          city_list: state.cityRadio === 1 ? [] : state.brandCityList,
          type: state.filters.goods_type == '1' ? ProductO['待上线'] : ProductO['已上线']
        };
        proxy.$http.post('/dsapi/citySave', params).then(res => {
          if (res.code == 200) {
            proxy.$message({
              type: 'success',
              message: '保存成功'
            });
          } else {
            proxy.$message({
              type: 'error',
              message: res.msg
            });
          }
        });
      },
      // 销量干预
      onSalesNumClose: () => {
        state.salesNumDialogShow = false;
      },
      onSalesNumSubmit: () => {
        state.salesNumDialogShow = false;
        const params = {
          product_id: state.currentRow.id,
          buy_count: state.currentRow.buy_count
        };
        proxy.$http.post('/goods/updateBuyCount', params).then(res => {
          if (res.code == 200) {
            proxy.$message({
              type: 'success',
              message: '保存成功'
            });
          } else {
            proxy.$message({
              type: 'error',
              message: res.msg
            });
          }
        });
      },
      // 设置配送规则
      setDistributionRule: row => {
        router.push({
          path: '/marketing/delivery-rule',
          query: {
            product_id: row.id,
            brand_id: row.brand_id,
            product_name: row.title
          }
        });
      },
      // 添加评论
      addComment: row => {
        state.currentProduct = row;
        // 初始化评论列表，默认5条
        state.commentList = Array.from({
          length: 5
        }, () => ({
          taste_score: '5',
          ontime_score: '5',
          detailed_score: '5',
          service_score: '5',
          comment: '',
          comment_time: new Date().toISOString().slice(0, 19).replace('T', ' ')
        }));
        state.commentDialogShow = true;
      },
      // 保存评论
      saveComments: () => {
        const comment_info = {
          product_id: state.currentProduct.id,
          product_name: state.currentProduct.title,
          comment: state.commentList.map(item => ({
            taste_score: item.taste_score,
            ontime_score: item.ontime_score,
            detailed_score: item.detailed_score,
            service_score: item.service_score,
            comment: item.comment
          }))
        };
        // 校验评论必填
        if (comment_info.comment.some(item => !item.comment)) {
          return proxy.$message({
            type: 'warning',
            message: '请填写评论'
          });
        }
        proxy.$http.post('/sys/admin/addProductComment', {
          comment_info
        }).then(res => {
          if (res.code == 200) {
            proxy.$message({
              type: 'success',
              message: '保存成功'
            });
            state.commentDialogShow = false;
          } else {
            proxy.$message({
              type: 'error',
              message: res.msg
            });
          }
        });
      },
      // 添加更多评论
      addMoreComments: () => {
        // 每次添加5条评论
        const newComments = Array.from({
          length: 5
        }, () => ({
          taste_score: '5',
          ontime_score: '5',
          detailed_score: '5',
          service_score: '5',
          comment: '',
          comment_time: new Date().toISOString().slice(0, 19).replace('T', ' ')
        }));
        state.commentList = [...state.commentList, ...newComments];
      }
    });
    const shelfRule = reactive({
      soldout_type: [{
        required: true,
        message: '请选择下架类型',
        trigger: 'blur'
      }]
    });
    const changeColor = ({
      row,
      rowIndex
    }) => {
      if (row.status == 0) {
        row.color = "red";
        return row;
      }
    };
    const maxPreSaleDate = Date.now() + 1000 * 60 * 60 * 24 * 30; // 预售时间为 30 天内
    const disabledPreSaleDate = date => {
      return date.getTime() < Date.now() || date.getTime() > maxPreSaleDate;
    };
    watchEffect(() => {
      state.isCityDisabled();
    });
    const hourList = ['00:00:00', '01:00:00', '02:00:00', '03:00:00', '04:00:00', '05:00:00', '06:00:00', '07:00:00', '08:00:00', '09:00:00', '10:00:00', '11:00:00', '12:00:00', '13:00:00', '14:00:00', '15:00:00', '16:00:00', '17:00:00', '18:00:00', '19:00:00', '20:00:00', '21:00:00', '22:00:00', '23:00:00', '24:00:00'];
    state.getBrandList();
    state.getCouponBrandList();
    onActivated(() => {
      if (route.query.o == 'product') {
        state.filters.status = route.query.status || null;
      }
      if (route.query.distribution_rule_id) {
        state.filters.distribution_rule_id = route.query.distribution_rule_id;
      }
      // 根据路由参数更新brand_id，没有参数时清空
      if (route.query.brand_id) {
        state.filters.brand_id = route.query.brand_id;
      }
      // 保留其他搜索状态，不重置
      state.getList();
    });
    state.onGetCityList();
    const handleDoubleClick = debounce(() => {
      state.doubleClickStockFlag = true;
      state.getList({
        stock: 2
      });
    }, 500);
    watch(() => state.brandCityList, (newVal, oldVal) => {
      let len = newVal.length;
      if (len === 0) {
        state.isSelectedAll = false;
        state.isIndeterminate = false;
      } else if (len === state.cityListLen) {
        state.isSelectedAll = true;
        state.isIndeterminate = false;
      } else {
        state.isIndeterminate = true;
      }
    }), watch(() => state.newCityList, (newVal, oldVal) => {
      if (state.product_detail.city_list && state.product_detail.city_list.length > 0) {
        state.cityRadio = 2;
        state.brandCityList = state.product_detail.city_list;
      } else {
        state.cityRadio = 1;
        state.brandCityList = [];
      }
    });
    const toEditCity = row => {
      state.currentRow = row;
      const {
        id
      } = row;
      const {
        goods_type
      } = state.filters;
      proxy.$http.post('/cake_api/product_details', {
        save_id: id,
        is_on_line: goods_type == '1' ? ProductO['待上线'] : ProductO['已上线']
      }).then(res => {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        state.product_detail = data;
        getCityList(data);
      });
      state.cityDialogShow = true;
    };
    const intervene = row => {
      state.salesNumDialogShow = true;
      state.currentRow = row;
    };
    // 获取品牌关联城市
    const getCityList = data => {
      proxy.$http.get('/cake_api/getCityListByBrandId', {
        brand_id: data === null || data === void 0 ? void 0 : data.brand_id
      }).then(res => {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        state.newCityList = data;
        // 组合全部城市ID集合，计算城市个数，供全选功能使用
        let cityListLen = 0;
        let cityIds = [];
        data.map(item => {
          const {
            options
          } = item;
          cityListLen += options.length;
          options.map(subItem => {
            // @ts-ignore
            cityIds.push(subItem.id);
          });
        });
        state.cityListLen = cityListLen;
        state.cityIds = cityIds;
      });
    };
    // 城市全选按钮状态监听
    const onIsSelectedAllChange = val => {
      if (val) {
        state.brandCityList = state.cityIds;
      } else {
        state.brandCityList = [];
      }
    };
    /************************************************** 批量上传电子券商品 -- begin **************************************************/
    const couponProductForm = reactive({
      couponProductDialog: false,
      couponProductBrandId: '',
      couponProductFile: null,
      couponProductErrorMsg: '',
      couponProductList: [],
      onFileChange: (file, fileList) => {
        couponProductForm.couponProductFile = file.raw;
      },
      onFileRemove: (file, fileList) => {
        couponProductForm.couponProductFile = null;
        couponProductForm.couponProductErrorMsg = '';
        couponProductForm.couponProductList = [];
      },
      onFileExceed: () => {
        proxy.$message({
          type: 'error',
          message: '只能上传一个文件，请删除后重新上传'
        });
      },
      openCouponProductDialog: () => {
        couponProductForm.couponProductDialog = true;
      },
      couponProductDialogClose: () => {
        couponProductForm.couponProductBrandId = '';
        couponProductForm.couponProductDialog = false;
        couponProductForm.couponProductList = [];
        couponProductForm.couponProductFile = null;
        proxy.$refs.uploadRef.clearFiles();
        state.fileList = [];
      },
      // 商品批量添加成功回调
      onCouponProductUpload: async () => {
        if (!couponProductForm.couponProductBrandId) {
          return proxy.$message({
            type: 'error',
            message: '请选择品牌'
          });
        }
        if (!couponProductForm.couponProductFile) {
          return proxy.$message({
            type: 'error',
            message: '请选择文件'
          });
        }
        const {
          code,
          data,
          msg
        } = await proxy.$http.post('/opsapi/excel_fileput_coupon_new', {
          brand_id: couponProductForm.couponProductBrandId,
          file: couponProductForm.couponProductFile
        }, true);
        if (code != 200) {
          return couponProductForm.couponProductErrorMsg = `*${msg}`;
        }
        couponProductForm.couponProductList = data;
      },
      onCouponProductUploadSure: async () => {
        if (couponProductForm.couponProductList.length == 0) {
          return proxy.$message({
            type: 'error',
            message: '未识别到商品信息'
          });
        }
        const {
          code,
          data,
          msg
        } = await proxy.$http.post('/opsapi/save_products_from_excel', {
          product_list: couponProductForm.couponProductList
        });
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        proxy.$message({
          type: 'success',
          message: '上传成功'
        });
        state.getList();
        couponProductForm.couponProductDialogClose();
        couponProductForm.couponProductErrorMsg = '';
      }
    });
    /************************************************** 批量上传电子券商品 -- end **************************************************/
    /************************************************** 批量更改商品价格 -- begin **************************************************/
    // 根据品牌导出上架商品
    const onExportProductByBrand = () => {
      if (!state.filters.brand_id) {
        return proxy.$message({
          type: 'error',
          message: '请先选择品牌'
        });
      }
      downloadFile('/opsapi/download_online_product', {
        brand_id: state.filters.brand_id
      });
    };
    const editPriceForm = reactive({
      editPriceDialog: false,
      editPriceBrandId: '',
      editPriceFile: null,
      editPriceFileList: [],
      onEditPriceFileChange: (file, fileList) => {
        editPriceForm.editPriceFile = file.raw;
      },
      onEditPriceFileRemove: (file, fileList) => {
        editPriceForm.editPriceFile = null;
      },
      onEditPriceFileExceed: () => {
        proxy.$message({
          type: 'error',
          message: '只能上传一个文件，请删除后重新上传'
        });
      },
      openEditPriceDialog: () => {
        editPriceForm.editPriceDialog = true;
      },
      editPriceFormDialogClose: () => {
        editPriceForm.editPriceBrandId = '';
        editPriceForm.editPriceDialog = false;
        editPriceForm.editPriceFileList = [];
        editPriceForm.editPriceFile = null;
        proxy.$refs.editPriceForm.clearFiles();
      },
      // 商品批量添加成功回调
      onEditPriceUpload: async () => {
        if (!editPriceForm.editPriceBrandId) {
          return proxy.$message({
            type: 'error',
            message: '请选择品牌'
          });
        }
        if (!editPriceForm.editPriceFile) {
          return proxy.$message({
            type: 'error',
            message: '请选择文件'
          });
        }
        const {
          code,
          data,
          msg
        } = await proxy.$http.post('/opsapi/update_excel_fileput', {
          brand_id: editPriceForm.editPriceBrandId,
          file: editPriceForm.editPriceFile
        }, true);
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        proxy.$message({
          type: 'success',
          message: '保存成功'
        });
        state.getList();
      }
    });
    /************************************************** 批量更改商品价格 -- end **************************************************/
    return {
      ...toRefs(state),
      userGroups,
      goods,
      checkAdd,
      cityList,
      hourList,
      disabledPreSaleDate,
      offTypes,
      filterTypes,
      Keys,
      store,
      shelfRule,
      router,
      CheckStatus,
      ProductO,
      changeColor,
      isKd,
      handleDoubleClick,
      toEditCity,
      getCityList,
      onIsSelectedAllChange,
      intervene,
      isSnacks,
      isBeforeMarch31,
      ...toRefs(couponProductForm),
      onExportProductByBrand,
      ...toRefs(editPriceForm)
    };
  }
});